var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.538 10h-7.076c-.434 0-.839-.158-1.145-.467a1.894 1.894 0 0 1-.49-.948c-.109-.504-.062-1.065.067-1.585H10C9 7 8 8 8 9v16c0 1 1 2 2 2h12c1 0 2-1 2-2V9c0-1-1-2-2-2h-.894c.129.52.176 1.081.067 1.585-.066.307-.205.66-.49.948a1.589 1.589 0 0 1-1.145.467zm.338 4.326c.142.21.213.59-.071.97-.898 1.26-1.832 2.876-2.731 4.432-.576.996-1.139 1.969-1.668 2.808a1.132 1.132 0 0 1-.887.464c-.178 0-.355-.042-.461-.169a1.209 1.209 0 0 1-.426-.548c-.15-.314-.304-.626-.458-.938-.395-.804-.79-1.608-1.139-2.435C12 18.826 12 18.74 12 18.615c0-.211.071-.422.213-.548.24-.19.658-.193.89.084l1.451 1.813c.722-.767 1.416-1.69 2.113-2.615.762-1.012 1.527-2.028 2.333-2.849.347-.353.5-.5.876-.174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.462 9h7.076C21 9 20 5 18 5h-4c-2 0-3 4-1.538 4z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/Clipboard_Check.f9ae66d9e3a0230ddca9d3ecfe393f22.svg";
export { ForwardRef as ReactComponent };